import { Overdue, Rejected, Confirm } from './components/pins-status'

const pinsVariantOptions = {
  'GRADIENT-YELLOW': 'gradient-yellow',
  'GRADIENT-ORANGE': 'gradient-orange',
  'GRADIENT-RED': 'gradient-red',
  'GRADIENT-PINK': 'gradient-pink',
  'GRADIENT-PURPLE': 'gradient-purple',
  'GRADIENT-VIOLET': 'gradient-violet',
  'GRADIENT-DARKBLUE': 'gradient-darkblue',
  'GRADIENT-BLUE': 'gradient-blue',
  'GRADIENT-TURQUOISE': 'gradient-turquoise',
  'GRADIENT-PETROL': 'gradient-petrol',
  'GRADIENT-DARKGREEN': 'gradient-darkgreen',
  'GRADIENT-GREEN': 'gradient-green',
  'GRADIENT-OCHRE': 'gradient-ochre',
  'GRADIENT-MUESLI': 'gradient-muesli',
  'GRADIENT-DARKBROWN': 'gradient-darkbrown',
  'GRADIENT-GRAY': 'gradient-gray',
  'FLAT-YELLOW': 'flat-yellow',
  'FLAT-ORANGE': 'flat-orange',
  'FLAT-RED': 'flat-red',
  'FLAT-PINK': 'flat-pink',
  'FLAT-PURPLE': 'flat-purple',
  'FLAT-VIOLET': 'flat-violet',
  'FLAT-DARKBLUE': 'flat-darkblue',
  'FLAT-BLUE': 'flat-blue',
  'FLAT-TURQUOISE': 'flat-turquoise',
  'FLAT-PETROL': 'flat-petrol',
  'FLAT-DARKGREEN': 'flat-darkgreen',
  'FLAT-GREEN': 'flat-green',
  'FLAT-OCHRE': 'flat-ochre',
  'FLAT-MUESLI': 'flat-muesli',
  'FLAT-DARKBROWN': 'flat-darkbrown'
}

const pinsStatusVariantOptions = {
  PROGRESS: 'progress',
  OVERDUE: 'overdue',
  REJECTED: 'rejected',
  COMPLETED: 'completed',
  CLOSED: 'closed'
}

const pinsStatusComponentOptions = {
  [pinsStatusVariantOptions.PROGRESS]: null,
  [pinsStatusVariantOptions.OVERDUE]: <Overdue />,
  [pinsStatusVariantOptions.REJECTED]: <Rejected />,
  [pinsStatusVariantOptions.COMPLETED]: <Confirm />
}

const pinsChildrenSizeOptions = {
  [pinsStatusVariantOptions.PROGRESS]: {
    scale: 9.5,
    translate: '2.75, 2'
  },
  [pinsStatusVariantOptions.OVERDUE]: {
    scale: 4,
    translate: '8,8'
  },
  [pinsStatusVariantOptions.REJECTED]: {
    scale: 4,
    translate: '33,35'
  },
  [pinsStatusVariantOptions.COMPLETED]: {
    scale: 4,
    translate: '34,35'
  },
  [pinsStatusVariantOptions.CLOSED]: {
    scale: 4,
    translate: '8,8'
  }
}

const pinsVariantComponentOptions = {
  [pinsVariantOptions['GRADIENT-YELLOW']]: {
    fill: 'url(#paint0_linear_9532_882)',
    gradientColor: (
      <>
        <stop stopColor="#FFC93E" />
        <stop offset="1" stopColor="#DDAE36" />
        <stop offset="1" stopColor="#BD952E" />
        <stop offset="1" stopColor="#80651F" />
      </>
    )
  },
  [pinsVariantOptions['GRADIENT-ORANGE']]: {
    fill: 'url(#paint0_linear_9532_380)',
    gradientColor: (
      <>
        <stop stopColor="#FF9533" />
        <stop offset="1" stopColor="#DE812C" />
        <stop offset="1" stopColor="#BF6F26" />
        <stop offset="1" stopColor="#804B1A" />
      </>
    )
  },
  [pinsVariantOptions['GRADIENT-RED']]: {
    fill: 'url(#paint0_linear_9532_169)',
    gradientColor: (
      <>
        <stop stopColor="#EA4444" />
        <stop offset="1" stopColor="#AE3333" />
        <stop offset="1" stopColor="#752222" />
      </>
    )
  },
  [pinsVariantOptions['GRADIENT-PINK']]: {
    fill: 'url(#paint0_linear_9532_250)',
    gradientColor: (
      <>
        <stop stopColor="#FF668E" />
        <stop offset="1" stopColor="#BD4C69" />
        <stop offset="1" stopColor="#803347" />
      </>
    )
  },
  [pinsVariantOptions['GRADIENT-PURPLE']]: {
    fill: 'url(#paint0_linear_9532_321)',
    gradientColor: (
      <>
        <stop stopColor="#C95FAB" />
        <stop offset="1" stopColor="#96477F" />
        <stop offset="1" stopColor="#653056" />
      </>
    )
  },
  [pinsVariantOptions['GRADIENT-VIOLET']]: {
    fill: 'url(#paint0_linear_9532_1038)',
    gradientColor: (
      <>
        <stop stopColor="#A25AD6" />
        <stop offset="1" stopColor="#79439F" />
        <stop offset="1" stopColor="#512D6B" />
      </>
    )
  },
  [pinsVariantOptions['GRADIENT-DARKBLUE']]: {
    fill: 'url(#paint0_linear_9532_1126)',
    gradientColor: (
      <>
        <stop stopColor="#2859AF" />
        <stop offset="1" stopColor="#1F4486" />
        <stop offset="1" stopColor="#142D58" />
      </>
    )
  },
  [pinsVariantOptions['GRADIENT-BLUE']]: {
    fill: 'url(#paint0_linear_9532_282)',
    gradientColor: (
      <>
        <stop stopColor="#4D8CE8" />
        <stop offset="1" stopColor="#3A68AD" />
        <stop offset="1" stopColor="#274674" />
      </>
    )
  },
  [pinsVariantOptions['GRADIENT-TURQUOISE']]: {
    fill: 'url(#paint0_linear_9532_130)',
    gradientColor: (
      <>
        <stop stopColor="#00D3C9" />
        <stop offset="1" stopColor="#009E96" />
        <stop offset="1" stopColor="#006A65" />
      </>
    )
  },
  [pinsVariantOptions['GRADIENT-PETROL']]: {
    fill: 'url(#paint0_linear_9532_417)',
    gradientColor: (
      <>
        <stop stopColor="#398D9B" />
        <stop offset="1" stopColor="#2B6A75" />
        <stop offset="1" stopColor="#1D474E" />
      </>
    )
  },
  [pinsVariantOptions['GRADIENT-DARKGREEN']]: {
    fill: 'url(#paint0_linear_9532_905)',
    gradientColor: (
      <>
        <stop stopColor="#008556" />
        <stop offset="1" stopColor="#005F3D" />
        <stop offset="1" stopColor="#00432B" />
      </>
    )
  },
  [pinsVariantOptions['GRADIENT-GREEN']]: {
    fill: 'url(#paint0_linear_9532_960)',
    gradientColor: (
      <>
        <stop stopColor="#91D656" />
        <stop offset="1" stopColor="#6C9F40" />
        <stop offset="1" stopColor="#496B2B" />
      </>
    )
  },
  [pinsVariantOptions['GRADIENT-OCHRE']]: {
    fill: 'url(#paint0_linear_9532_983)',
    gradientColor: (
      <>
        <stop stopColor="#DDBB7C" />
        <stop offset="0.985222" stopColor="#C0A26C" />
        <stop offset="0.995074" stopColor="#A48A5C" />
        <stop offset="1" stopColor="#6F5E3E" />
      </>
    )
  },
  [pinsVariantOptions['GRADIENT-MUESLI']]: {
    fill: 'url(#paint0_linear_9532_70)',
    gradientColor: (
      <>
        <stop stopColor="#99815B" />
        <stop offset="1" stopColor="#726044" />
        <stop offset="1" stopColor="#4D412E" />
      </>
    )
  },
  [pinsVariantOptions['GRADIENT-DARKBROWN']]: {
    fill: 'url(#paint0_linear_9532_190)',
    gradientColor: (
      <>
        <stop stopColor="#5B5142" />
        <stop offset="1" stopColor="#363027" />
        <stop offset="1" stopColor="#12100D" />
      </>
    )
  },
  [pinsVariantOptions['FLAT-YELLOW']]: {
    fill: '#FFC93E'
  },
  [pinsVariantOptions['FLAT-ORANGE']]: {
    fill: '#FF9533'
  },
  [pinsVariantOptions['FLAT-RED']]: {
    fill: '#EA4444'
  },
  [pinsVariantOptions['FLAT-PINK']]: {
    fill: '#FF668E'
  },
  [pinsVariantOptions['FLAT-PURPLE']]: {
    fill: '#C95FAB'
  },
  [pinsVariantOptions['FLAT-VIOLET']]: {
    fill: '#A25AD6'
  },
  [pinsVariantOptions['FLAT-DARKBLUE']]: {
    fill: '#2859AF'
  },
  [pinsVariantOptions['FLAT-BLUE']]: {
    fill: '#4D8CE8'
  },
  [pinsVariantOptions['FLAT-TURQUOISE']]: {
    fill: '#00D3C9'
  },
  [pinsVariantOptions['FLAT-PETROL']]: {
    fill: '#398D9B'
  },
  [pinsVariantOptions['FLAT-DARKGREEN']]: {
    fill: '#008556'
  },
  [pinsVariantOptions['FLAT-GREEN']]: {
    fill: '#91D656'
  },
  [pinsVariantOptions['FLAT-OCHRE']]: {
    fill: '#DDBB7C'
  },
  [pinsVariantOptions['FLAT-MUESLI']]: {
    fill: '#99815B'
  },
  [pinsVariantOptions['FLAT-DARKBROWN']]: {
    fill: '#5B5142'
  },
  [pinsVariantOptions['GRADIENT-GRAY']]: {
    fill: 'url(#paint0_linear_10101_1166)',
    gradientColor: (
      <>
        <stop stopColor="#787887" />
        <stop offset="1" stopColor="#3C3C44" />
      </>
    )
  }
}

export {
  pinsVariantOptions,
  pinsStatusVariantOptions,
  pinsStatusComponentOptions,
  pinsChildrenSizeOptions,
  pinsVariantComponentOptions
}
